// extracted by mini-css-extract-plugin
export default {"row":"PersonToTagRow_row__M4vds","checkbox":"PersonToTagRow_checkbox__iUktX","completeNameContainer":"PersonToTagRow_completeNameContainer__sbvDH"};